import Toast from '../../../components/toast/toast';

class CopyText {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		if (!this.el) return;

		this.el.addEventListener('click', () => {
			const text = this.el.textContent.trim();

			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard
					.writeText(text)
					.then(() => this.showToast())
					.catch(() => this.fallbackCopy(text));
			} else {
				this.fallbackCopy(text);
			}
		});
	}

	showToast() {
		const toastText = this.el.dataset.copyText || 'Скопировано!';
		Toast.open('toast-copy-text', toastText);
	}

	fallbackCopy(text) {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'absolute';
		textarea.style.left = '-9999px';
		document.body.appendChild(textarea);

		textarea.select();
		try {
			document.execCommand('copy');
			this.showToast();
		} catch (err) {
			alert('Не удалось скопировать текст');
		}

		document.body.removeChild(textarea);
	}
}

document.querySelectorAll('[data-copy-text]').forEach((el) => new CopyText(el));

export default CopyText;
